import React from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import CreditorSelector from '../../CreditorSelector';
import FilterGroup from '../FilterGroup';
import FilterOption from '../FilterOption';
const CreditorsGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.creditorsGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.creditorIds && caseFilter.creditorIds.length), onDeactivate: () => c.insights.clearFilter('creditorIds') },
            React.createElement(CreditorSelector, { style: {
                    width: '100%',
                    marginRight: '20px',
                }, onChange: props.onChange }))));
};
export default CreditorsGroup;
//# sourceMappingURL=CreditorsGroup.js.map